<div class="l_flexbar guts-p-h-0 full-width">
  <div class="icon-spot bg-color-ebony-a08 center-item guts-m-h-1 __icon">
    <df-icon icon="tag" size="medium" class="color-ebony-a61"></df-icon>
  </div>
  <div class="par par--small">
    <span
      [innerHtml]="
        item.title | encodeToEntities | highlightSearchText: searchTerm
      "
    ></span>
    <img
      class="tag-endorsed-img v-bottom"
      *ngIf="item.endorsedSrc"
      [src]="item.endorsedSrc + '?brandlogo'"
      [attr.alt]="item.endorsedAlt"
    />
  </div>
</div>
